import React, { useEffect } from "react";
import { Routes, Route, Link, useLocation } from "react-router-dom";
import Login from "./components/Login";
import TaskList from "./TaskList";
import Reports from "./Reports";
import PatientSelector from "./PatientSelector";
import VideoWall from "./VideoWall";
import PatientNavigator from "./PatientNavigator";
import PatientNavigator2 from "./PatientNavigator2";
import PatientNavigator3 from "./PatientNavigator3";
import AppointmentScheduler from "./AppointmentScheduler";
import AppointmentScheduler2 from "./AppointmentScheduler2";
import PrivateRoute from "./PrivateRoute";
import PatientDashboard from "./PatientDashboard";
import PatientDashboard2 from "./PatientDashboard2";
import PatientDashboard3 from "./PatientDashboard3";
import '@fortawesome/fontawesome-free/css/all.min.css';
import logo2 from "./logo2.png";

import { getAuth, signOut, onAuthStateChanged } from "firebase/auth";
window.auth = getAuth();

function App() {
  const auth = getAuth();
  const location = useLocation();

  // Show login header ONLY on the login page
  const showLoginHeader = location.pathname === "/";

  // Auto-logout after 24 hours
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (!user) return;

      const loginTime = parseInt(localStorage.getItem("loginTime") || "0");
      const now = Date.now();

      if (!loginTime) {
        localStorage.setItem("loginTime", now.toString());
        return;
      }

      if (now - loginTime > 86400000) {
        signOut(auth);
        localStorage.removeItem("loginTime");
        window.location.href = "/";
      }
    });

    return () => unsubscribe();
  }, [auth]);

  return (
    <div>
      {/* 🔵 Login Header – ONLY visible on "/" */}
      {showLoginHeader && (
        <nav style={styles.navbar}>
          <img src={logo2} alt="Logo" className="nav-logo" />
          <ul style={styles.navList}>
            <li style={styles.navItem}>
              <Link to="/" style={styles.link}>Login</Link>
            </li>
          </ul>
        </nav>
      )}

      <Routes>
        <Route path="/" element={<Login />} />

        <Route path="/tasks" element={<PrivateRoute><TaskList /></PrivateRoute>} />
        <Route path="/video-wall" element={<PrivateRoute><VideoWall /></PrivateRoute>} />
        <Route path="/navigator-331" element={<PrivateRoute><PatientNavigator /></PrivateRoute>} />
        <Route path="/navigator-228" element={<PrivateRoute><PatientNavigator2 /></PrivateRoute>} />
        <Route path="/navigator-145" element={<PrivateRoute><PatientNavigator3 /></PrivateRoute>} />
        <Route path="/patient-list" element={<PrivateRoute><PatientSelector /></PrivateRoute>} />
        <Route path="/reports" element={<PrivateRoute><Reports /></PrivateRoute>} />
        <Route path="/outpatient-schedule" element={<PrivateRoute><AppointmentScheduler /></PrivateRoute>} />
        <Route path="/outpatient-schedule2" element={<PrivateRoute><AppointmentScheduler2 /></PrivateRoute>} />
        <Route path="/patient-dashboard" element={<PrivateRoute><PatientDashboard /></PrivateRoute>} />
        <Route path="/patient-dashboard2" element={<PrivateRoute><PatientDashboard2 /></PrivateRoute>} />
        <Route path="/patient-dashboard3" element={<PrivateRoute><PatientDashboard3 /></PrivateRoute>} />
      </Routes>
    </div>
  );
}

const styles = {
  navbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#007bff",
    color: "white",
    padding: "10px 20px",
  },
  navList: {
    listStyle: "none",
    display: "flex",
    gap: "15px",
    margin: 0,
    padding: 0,
  },
  navItem: {
    display: "inline",
  },
  link: {
    color: "white",
    textDecoration: "none",
    fontWeight: "bold",
  },
};

export default App;
